import { render, staticRenderFns } from "./CreateExtrudePanel.vue?vue&type=template&id=298250d8&scoped=true"
import script from "./CreateExtrudePanel.vue?vue&type=script&lang=js"
export * from "./CreateExtrudePanel.vue?vue&type=script&lang=js"
import style0 from "./CreateExtrudePanel.vue?vue&type=style&index=0&id=298250d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298250d8",
  null
  
)

export default component.exports